<template>
  <b-row>
    <RegionOverview :lgSize="12"></RegionOverview>
    <DeliveredCompany
      ref="shipLine"
      v-if="!detailsShip"
      :lgSize="12"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailViewShip="switchViewShip"
      @modalLocationShip="modalLocationShip"
    ></DeliveredCompany>
    <ActiveBacklog2
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      :details="0"
      @detailView="switchView"
      @modalLocation="modalLocation"
    ></ActiveBacklog2>
    <ShippedByFNS
      ref="shipLine"
      v-if="!detailsShip"
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailViewShip="switchViewShip"
      @modalLocationShip="modalLocationShip"
    ></ShippedByFNS>
    <ReceivedByFNS
      ref="shipLine"
      v-if="!detailsShip"
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailViewShip="switchViewShip"
      @modalLocationShip="modalLocationShip"
    ></ReceivedByFNS>
    <RepairAnalytics
      v-if="!detailsRepair"
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailViewRepair="switchViewRepair"
    ></RepairAnalytics>
    <HistoricalData
      v-if="!detailsHistorical"
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailViewHistorical="switchViewHistorical"
    ></HistoricalData>
  </b-row>
</template>

<script>
import DeliveredCompany from "../components/Delivered-Company";

import ActiveBacklog from "../components/ActiveBacklog-Column";
import ActiveBacklog2 from "../components/ActiveBacklog-Stacked";

import ReceivedByFNS from "../components/ReceivedByFNS-ColumnAlpha";

import ShippedByFNS from "../components/ShippedByFNS-ColumnAlpha";
import ShippedByFNS2 from "../components/ShippedByFNS-Stacked";

import {
  default as RepairAnalytics,
  default as RepairAnalytics2
} from "../components/RepairAnalytics-Stacked";

import {
  default as HistoricalData,
  default as HistoricalData2
} from "../components/HistoricalData-Stacked";

import RegionOverview from "../components/RegionOverview";

export default {
  name: "dashboard",
  components: {
    DeliveredCompany,
    ActiveBacklog,
    ActiveBacklog2,
    ShippedByFNS,
    ShippedByFNS2,
    RepairAnalytics,
    RepairAnalytics2,
    HistoricalData,
    HistoricalData2,
    RegionOverview,
    ReceivedByFNS
  },
  data: function() {
    return {
      details: false,
      detailsShip: false,
      detailsRepair: false,
      detailsHistorical: false,
      portalMsg: ""
    };
  },
  methods: {
    switchView() {
      if (this.details == false) {
        this.details = true;
      } else {
        this.details = false;
      }
    },
    switchViewShip() {
      if (this.detailsShip == false) {
        this.detailsShip = true;
      } else {
        this.detailsShip = false;
      }
    },
    switchViewRepair() {
      if (this.detailsRepair == false) {
        this.detailsRepair = true;
      } else {
        this.detailsRepair = false;
      }
    },
    switchViewHistorical() {
      if (this.detailsHistorical == false) {
        this.detailsHistorical = true;
      } else {
        this.detailsHistorical = false;
      }
    }
  }
};
</script>

<style>
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-label {
  color: #00bf8f !important;
  fill: #00bf8f !important;
}
.markan {
  position: relative;
  /*height: 400px;*/
  .map-container {
    height: 100%;
  }
  .btn-map-fullscreen {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 36px;
    height: 36px;
    padding: 0;
    font-size: 36px;
    line-height: 36px;
    text-align: center;
    outline: none;
  }
  &.fullscreen {
    width: 100%;
    height: 100%;
  }
}
.power {
  background-color: #f86c6b !important;
}
</style>
